const SMALL_SIZE = 10;
const MED_SIZE = 15;
const BIG_SIZE = 70;

export const MarkerStyles = {
  position: "absolute",
  width: SMALL_SIZE,
  height: SMALL_SIZE,
  left: -SMALL_SIZE / 2,
  top: -SMALL_SIZE / 2,

  borderRadius: SMALL_SIZE,
  backgroundColor: "white",
  textAlign: "left",
  color: "#E66900",
  fontSize: 16,
  padding: 4,
  width: 20,
  height: 20,
  border: "1px solid #515151",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};

export const MarkerStylesHover = {
  ...MarkerStyles,

  border: "1px solid #515151",
  color: "#078BB3",
  width: 150,
  height: 60,
  borderRadius: 15,
  padding: 10,
  left: -BIG_SIZE / 2,
  top: -BIG_SIZE / 2,
  zIndex: 9999
};

export const CardEventStyleHover = {
  backgroundColor: "#E66900"
};

export const PlannedPdcStyle = {
  position: "absolute",
  width: MED_SIZE,
  height: MED_SIZE,
  left: -MED_SIZE / 2,
  top: -MED_SIZE / 2,

  borderRadius: MED_SIZE,
  backgroundColor: "white",
  textAlign: "left",
  color: "#E66900",
  fontSize: 16,
  padding: 4,
  width: 22,
  height: 22,
  border: "5px solid #E66900",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
};



// WEBPACK FOOTER //
// src/containers/activite/map/markerStyles.js